import initActionTypes from "./init.types";

export const initMainApp = () => ({
  type: initActionTypes.INIT_MAIN,
});
